










import {
    Vue, Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator'

@Component
export default class InputNumberStep extends Vue {
    @Prop({default: 0}) value!: number

    @Prop({default: 1}) step!: number

    @Prop({default: null}) max!: number

    @Prop({default: null}) min!: number

    change(val) {
        let result = +this.value + this.step * val
        if ((this.max != null && result > this.max)
            || (this.min != null && result < this.min)) {
            return
        }
        this.$emit('input', result)
    }
}
